import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { Login, LoginResponse, TokenResponse } from '../../models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly API = `${environment.api_url}/login`;

  constructor(private http: HttpClient, private router: Router) {}

  authenticate(body: Login): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.API}`, body);
  }

  storeUserData(user: LoginResponse): void {
    delete user.senha;
    localStorage.setItem('user', JSON.stringify(user));
  }

   isAuthenticated(): boolean {
    const user = localStorage.getItem('user');
    return !!user;
  }

  logout(): void {
  localStorage.removeItem('user');
  sessionStorage.clear();
  this.router.navigate(['authentication/login']);
}

  alterarSenha(email: string): Observable<void> {
    return this.http.post<void>(`${this.API}/alterarSenha`, {
      email: email
    });
  }

  getIdUsuario(token: string): Observable<TokenResponse> {
    return this.http.get<TokenResponse>(`${this.API}/token/${token}`);
  }
}
